import request from "@/axios.js";
import Netlink from "./Netlink";

export default class Purchase {
	/**
	 * Purchase class
	 * @property {number} price - a price.
	 * @property {number} sell_price - a price.
	 * @property {number} recurrence - a recurrence.
	 * @property {number} margin_price - an marginPrice.
	 * @property {number} margin_rate - a marginRate.
	 * @property {number} is_billable - a can be payed by the client or not.
	 * @property {string} commentary - a commentary.
	 * @property {Date} boughtAt - a boughtAt.
	 * @property {Date} period_date - a period.
	 * @property {number} contract_id - ID of a contract.
	 * @property {number} contract_society_id - ID of a society.
	 * @property {number} users_id - ID of a user.
	 * @property {number} service_id - Service related to purchase.
	 * @property {number} is_delivered - Bought item has been delivered?
	 * @property {number} mission_id - ID of a mission.
	 */
	constructor(purchase) {
		this.id = purchase.id || null;
		this.price = purchase.price || 0;
		this.recurrence = purchase.recurrence;
		this.sellPrice = purchase.sell_price;
		this.marginPrice = purchase.margin_price;
		this.marginRate = purchase.margin_rate;
		this.isBillable = purchase.is_billable;
		this.commentary = purchase.commentary;
		this.boughtAt = purchase.bought_at || purchase.boughtAt;
		this.inputDate = purchase.input_date || purchase.inputDate;
		this.invoiceDate = purchase.invoice_date || purchase.invoiceDate;
		this.contract_id = purchase.contract_id;
		this.contract_society_id = purchase.contract_society_id;
		this.users_id = purchase.users_id;
		this.service_id = purchase.service_id;
		this.is_delivered = purchase.is_delivered;
		this.recurrence_id = purchase.recurrence_id;
		this.recurrence_active = purchase.recurrence_active;
		this.recurrence_is_paid = purchase.recurrence_is_paid;
		this.recurrence_price = purchase.recurrence_price;
		this.recurrence_is_check = purchase.recurrence_is_check;
		this.recurrence_date = purchase.recurrence_date;
		this.user_id = purchase.user_id;
		this.user_firstname = purchase.user_firstname;
		this.user_lastname = purchase.user_lastname;
		this.mission_id = purchase.mission_id;
		this.period_date = purchase.period_date;
	}

	static getFormFields(){
		return {
			id: null,
			price: 0,
			recurrence: 0,
			sellPrice: 0,
			marginPrice: 0,
			marginRate: 0,
			isBillable: 0,
			commentary: null,
			boughtAt: null,
			inputDate: null,
			invoiceDate: null,
			netlink_id: null,
			contract_id: null,
			contract_society_id: null,
			users_id: null,
			service_id: null,
			is_delivered: 0,
			recurrence_id: 0,
			recurrence_active: 0,
			recurrence_is_paid: 0,
			recurrence_price: 0,
			recurrence_is_check: 0,
			recurrence_date: null,
			user_id: null,
			user_firstname: "",
			user_lastname: "",
			mission_id: null,
			period_date: null
		};
	}

	static getPurchasesForContract(contractId, callback) {
		request.get("/purchase/all/" + contractId)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	static getAllPurchasesWithRecurringForContract(contractId, callback) {
		request.get("/purchase/allrc/" + contractId)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	static updateRecurringPurchase(purchase, callback){
		let re = new RegExp("([T|Z])", "g");
		let formatedDate = purchase.recurrence_date.replace(re, " ");
		let params = {
			id: purchase.recurrence_id,
			price: purchase.recurrence_price,
			is_paid: purchase.recurrence_is_paid,
			date: formatedDate,
			purchase_id: purchase.id,
			is_check: purchase.recurrence_is_check,
		};
		request.post("/purchase/editrc", params)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	static updatePurchaseInvoiceDate(purchaseId, invoiceDate){
		return new Promise((resolve, reject) => {
			let formatedDate = invoiceDate ? invoiceDate.split("/").reverse().join("-") + " 02:00:00" : null;
			let params = {
				id: purchaseId,
				invoice_date: formatedDate,
			};
			request.post("/purchase/editinvoicedate", params)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	static updatePurchaseInvoiceDateForAll(listId, invoiceDate){
		return new Promise((resolve, reject) => {
			let formatedDate = invoiceDate ? invoiceDate.split("/").reverse().join("-") + " 02:00:00" : null;
			let params = {
				list_id: listId,
				invoice_date: formatedDate,
			};
			request.post("/purchase/editinvoicedateforall", params)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	delete(purchaseId, callback){
		Netlink.getNetlinksForPurchase(purchaseId, (err, result) => {
			if(err){
				callback(err, null);
			}
			if(result.data){
				//console.log(result.data);
				if(result.data.length > 0){
					//console.log("DELETE NETLINKS");
					//DELETE NETLINKS
					for(let oneNetlink of result.data){
						Netlink.delete(oneNetlink.id, (err, resultDelNetlink) => {
							if(err) callback(err, null);
							if(resultDelNetlink){
								//console.log(resultDelNetlink);
							}
						});
					}
					//DELETE PURCHASE
					request.delete("/purchase/delete/" + this.id)
						.then(res => {
							callback(null, res);
						})
						.catch(err => {
							callback(err, null);
						});
				}
				else{
					request.delete("/purchase/delete/" + this.id)
						.then(res => {
							callback(null, res);
						})
						.catch(err => {
							callback(err, null);
						});
				}
			}
		});

	}

	deleterc(recurrencePurchaseId, callback){
		Netlink.getNetlinksForRecurringPurchase(recurrencePurchaseId, (err, result) => {
			if(err){
				callback(err, null);
			}
			if(result.data){
				//console.log(result.data);
				if(result.data.length > 0){
					//console.log("DELETE NETLINKS");
					//DELETE NETLINKS
					for(let oneNetlink of result.data){
						Netlink.delete(oneNetlink.id, (err, resultDelNetlink) => {
							if(err) callback(err, null);
							if(resultDelNetlink){
								//console.log(resultDelNetlink);
							}
						});
					}
					//DELETE PURCHASE
					request.delete("/purchase/deleterc/" + this.recurrence_id)
						.then(res => {
							callback(null, res);
						})
						.catch(err => {
							callback(err, null);
						});
				}
				else{
					request.delete("/purchase/deleterc/" + this.recurrence_id)
						.then(res => {
							callback(null, res);
						})
						.catch(err => {
							callback(err, null);
						});
				}
			}
		});

	}
}
